export default "__VITE_ASSET__D_cG42R8__"